import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT } from '../../../../anamnesis/state/anamnesis/const'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectImageVersionList } from '../../../../customer/state/image/selector'
import { selectAnamnesisList } from '../../../../anamnesis/state/anamnesis/selector'
import * as processAction from '../../process-action'

export default createUIDefinition({
    taskName: taskName.RESCAN,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
            widgetProps: {
                excludeTemplateKeyList: [
                    ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
                ],
            },
        },
        {
            component: processUI.ANAMNESIS_EDIT_WIDGET_CONTAINER,
            widgetProps: {
                templateKey: ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
                hideIPR: true,
            },
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.CUSTOMER_IMAGE_UPLOAD_WIDGET,
            widgetProps: {
                skipImages: [
                    'lower-row-of-teeth',
                    'upper-row-with-aligner',
                    'lower-row-with-aligner',
                ],
            },
        },
        {
            component: processUI.TRANSITION_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.PATIENT_SCANNED_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.RESCAN_APPOINTMENT_TOGGLE_IMAGE_VIEW,
            taskPath: [],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
        selectImageVersionList,
        selectAnamnesisList,
    ],
    taskValidator: (
        task,
        processInstance,
        taskName,
        eventName,
        context,
        imageVersionList,
    ) => {
        const messageList = []
        const isImageNotComplete =
            (!!imageVersionList.other &&
                Object.keys(imageVersionList).length < 9) ||
                Object.keys(imageVersionList).length < 8

        if (isImageNotComplete) {
            messageList.push(
                createValidationMessage(
                    'Please take all pictures first.',
                    'validateAllPhotosUploaded',
                ),
            )
        }
        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/rescan.js